export function mapCountryFlag(inputText) {
    const countryCodeMap = {
      'mex': 'mx',
      'col': 'co',
      'estados unidos': 'us',
      'usa': 'us',
      'méxico': 'mx',
      'colombia': 'co',
      'can': 'ca'
    };
  
    const lowerInputText = inputText.toLowerCase().trim();
  
    if (countryCodeMap.hasOwnProperty(lowerInputText)) {
      return countryCodeMap[lowerInputText];
    } else {
      return '';
    }
}